import { mount } from '../../../js/dom-lifecycle';

export const copyToClipboard = function (url) {
    const el = document.createElement('textarea');
    el.value = url;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
};

mount('[data-bs-toggle="copy-to-clipboard"]').addEventListener('click', e => {
    const icon = e.currentTarget.querySelector('i');
    copyToClipboard(e.currentTarget.dataset.content);
    icon.textContent = 'check';
    setTimeout(() => icon.textContent = 'content_copy', 1000);
});
